export function resolveToken(token) {
  if (!token) {
    return null;
  }

  if (typeof token !== "string") {
    return null;
  }

  const unquoted = token.replace(/^"+|"+$/g, "").trim();

  return unquoted || null;
}

function tokenFromStorage(key) {
  try {
    const raw = localStorage.getItem(key);

    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);

    return resolveToken(typeof parsed === "string" ? parsed : null);
  } catch (e) {
    return resolveToken(localStorage.getItem(key));
  }
}

function tokenFromCookie(name) {
  if (typeof document === "undefined") {
    return null;
  }

  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`)
  );

  return match ? resolveToken(decodeURIComponent(match[1])) : null;
}

export function getBearerToken(storeToken) {
  return (
    resolveToken(storeToken) ||
    tokenFromStorage("access_token") ||
    tokenFromStorage("bearer_token") ||
    tokenFromCookie("default_auth_token") ||
    tokenFromCookie("auth_token_default")
  );
}
